import {applyMiddleware, createStore} from "@reduxjs/toolkit"
import reducers from "./core/redux/reducers"

const createStoreWithMiddleware = applyMiddleware()(createStore)
export default createStoreWithMiddleware(reducers)